import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/pageDirector.svg'
import _imports_1 from '@/assets/pageDirector/pageDirector_function.svg'
import _imports_2 from '@/assets/pageDirector/pageDirector_function_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-0727da94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left_mobile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "left_mobile_tbody" }
const _hoisted_4 = { class: "mobile_tbody_cv" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile_tbody_menu_txt" }, "聊天互动", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile_tbody_menu_txt" }, "在线观众", -1))
const _hoisted_9 = { class: "mobile_tbody_con" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"mobile_tbody_con_item\" data-v-0727da94><div class=\"item_avatar\" data-v-0727da94><img src=\"https://images.innocomn.com/avatar.png\" data-v-0727da94></div><div class=\"item_con\" data-v-0727da94><div class=\"item_con_name\" data-v-0727da94>上海市网友</div><div class=\"item_con_bubble\" data-v-0727da94>聊天记录</div></div></div>", 1)
const _hoisted_12 = { class: "right_work_btn" }
const _hoisted_13 = {
  key: 0,
  src: _imports_1,
  class: "work_btn_fun"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_2,
  class: "work_btn_fun"
}
const _hoisted_15 = { class: "mobile_tbody_send" }
const _hoisted_16 = { class: "tbody_send_box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tbody_send_avatar" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://images.innocomn.com/avatar.png" })
], -1))
const _hoisted_18 = { class: "tbody_send_in" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tbody_send_txt" }, "请输入...", -1))
const _hoisted_20 = { class: "tbody_send_icon" }

import { LiveInfo } from '@/store/modules/live/types';
import { computed, inject, unref, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { ModalData } from './type';

interface IProps {
  modelValue: ModalData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewMobile',
  props: {
    modelValue: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: ModalData;
};

_useCssVars(_ctx => ({
  "33f2484b": (form.value.mobile_meau_bg),
  "0340d252": (form.value.opacity_mobile_0),
  "0fbe2d9d": (form.value.mobile_meau_color),
  "487cc06a": (form.value.themeColor),
  "ecb74c9c": (form.value.mobile_bg),
  "0340d250": (form.value.opacity_mobile_1),
  "7c175a0c": (form.value.textColor2),
  "c6b675aa": (form.value.mobile_botton_bg),
  "7207230f": (form.value.mobile_send_bg),
  "6478b96b": (form.value.sendColor),
  "1e143f32": (iconStyle.value.like),
  "1e18cc00": (iconStyle.value.gift),
  "1e1327b6": (iconStyle.value.more)
}))

const userData = computed(() => useStore().state.user.userInfo);

const form = ref<ModalData>({
  topShow: false,
  logoUrl: ' ',
  videoCv: '',
  themeColor: '',
  pcBgColor: '',
  pcBgUrl: '',
  textColor1: ' ',
  textColor2: ' ',
  tabBgColor: '',
  pc_botton_bg: '',
  msgBgColor: '',
  sendBgColor: '',
  menuBgColor: '',
  topBbColor: '',
  msgColor: '',
  tabTitleColor: '',
  titleColor: '',
  sendColor: '',
  type: '0',
  mobile_bg: '',
  mobile_meau_bg: '',
  mobile_meau_color: '',
  mobile_send_bg: '',
});

form.value = unref(props.modelValue);
watch(
  () => props.modelValue,
  () => {
    form.value = unref(props.modelValue);
    init();
  }
);
const iconStyle = ref({
  like: '',
  gift: '',
  more: '',
});

const init = () => {
  switch (props.modelValue.type) {
    case '1':
      iconStyle.value.like = '#41474c';
      iconStyle.value.gift = '#394551';
      iconStyle.value.more = '#394551';
      form.value.mobile_botton_bg = '#232F3B';
      form.value.mobile_meau_color = '#FFFFFF';
      form.value.mobile_send_bg = '#394551';
      break;
    case '2':
      iconStyle.value.like = '#dec58d47';
      iconStyle.value.gift = '#ffe1e9';
      iconStyle.value.more = '#def5f2';
      form.value.mobile_botton_bg = '#D82737';
      form.value.mobile_meau_color = '#ED9D67';
      form.value.mobile_send_bg = '#F2C277';
      break;
    case '3':
      iconStyle.value.like = '#aaffe636';
      iconStyle.value.gift = '#00000000';
      iconStyle.value.more = '#00000000';
      form.value.mobile_botton_bg = '#000D2F';
      form.value.mobile_meau_color = '#E2E8F0';
      form.value.mobile_send_bg = '#2E858C';
      break;
    case '4':
      form.value.mobile_botton_bg = '#162231';
      form.value.mobile_send_bg = '#0A1626';
      form.value.mobile_meau_color = '#ffffff';
      break;
    default:
      iconStyle.value.like = '#fff4e3';
      iconStyle.value.gift = '#ffe4ea';
      iconStyle.value.more = '#e8fffc';
      form.value.mobile_botton_bg = '#F7F7F7';
      form.value.mobile_meau_color = '#505D6F';
      form.value.mobile_send_bg = '#FFFFFF';
      break;
  }
};
init();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (form.value.videoCv)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: form.value.videoCv
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mobile_tbody_menu", { shadow: form.value.type === '0' }])
      }, [
        (form.value.mobile_tab_bgimg)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: form.value.mobile_tab_bgimg,
              class: "mobile_tbody_menu_img"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        _hoisted_7,
        _hoisted_8
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        (form.value.mobile_msg_bgimg)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "right_work_bg",
              src: form.value.mobile_msg_bgimg
            }, null, 8, _hoisted_10))
          : _createCommentVNode("", true),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (props.modelValue.type === '0')
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : (_openBlock(), _createElementBlock("img", _hoisted_14)),
          _createVNode(_component_svg_icon, {
            "icon-class": "pageDirector_like",
            class: "btn_like"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", null, [
              _createVNode(_component_svg_icon, {
                "icon-class": "page_director_emoji",
                class: "tbody_send_txt"
              }),
              _createTextVNode("  "),
              _createVNode(_component_svg_icon, {
                "icon-class": "page_director_img",
                class: "tbody_send_txt"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_svg_icon, {
            "icon-class": "pageDirector_gift",
            class: "btn_gift"
          }),
          _createVNode(_component_svg_icon, {
            "icon-class": "pageDirector_more",
            class: "btn_more"
          })
        ])
      ])
    ])
  ]))
}
}

})